import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from '@/shared/Accordion';
import { AnnotationItem } from '@/components/Map/Drawer/BioEntityDrawer/AnnotationItem';
import React from 'react';
import { PinItem } from '../PinsList/PinsList.types';
import {
  getEntityDescriptions,
  getEntityNames,
  getEntitySynonyms,
} from './AccordionsDetails.utils';

interface AccordionsDetailsProps {
  pinsList: PinItem[];
}

export const AccordionsDetails = ({ pinsList }: AccordionsDetailsProps): JSX.Element => {
  return (
    <div data-testid="accordions-details" className="mb-4">
      <div className="px-6 py-4">
        <span className="font-semibold">Name:</span> {getEntityNames(pinsList)}
      </div>
      <div className="px-6 py-4">
        <span className="font-semibold">Source:</span>
        <div className="flex max-h-full flex-col gap-2 overflow-x-hidden pt-2">
          {pinsList.map(pinItem =>
            pinItem.data.references.map(reference => (
              <AnnotationItem
                key={reference.id}
                type={reference.type}
                link={reference.link}
                resource={reference.resource}
              />
            )),
          )}
        </div>
      </div>
      <Accordion allowZeroExpanded className="px-6">
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton>Details</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div data-testid="details-description" className="mb-5">
              <span className="font-semibold">Description:</span> {getEntityDescriptions(pinsList)}
            </div>
            <div>
              <span className="font-semibold">Synonyms:</span> {getEntitySynonyms(pinsList)}
            </div>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};
